import type { OrganisationIntegrationSettingsLocales } from '../types';

const organisationIntegrationSettingsLocales: OrganisationIntegrationSettingsLocales =
  {
    authenticationSuccessful: 'Successfully integrated',
    authenticationSuccessfulMessage:
      'The authentication was successful. You can now fetch jobs from SDB and import them into Tadaah.',
    backToFetchJobs: 'Back to Fetch Jobs',
    backToSettings: 'Back to Settings',
    break: 'Break',
    certificates: 'Certificates (optional)',
    competence: 'Competence',
    connectSDBInfoParagraph1: `With the SDB Integration you can fetch jobs that can then be created in Tadaah. 
                This way you can fill gaps faster.`,
    connectSDBInfoParagraph2: `To use the integration, Tadaah needs an API key and the name of the organisation account. The information on how to set this up is documented on the SDB platform. 

Please ensure you complete the following steps:
  1. Create an API Key.
  2. Provide access to Tadaah "Uitzendbureau" to give access to the API.
  3. Ensure that you set up the jobs to send it to Tadaah.

To send a job to Tadaah:
  1. Set a job from the "ballenbak" in RoosterPlan to "flex".
  2. Go to FlexPlan and accept the request.
  3. Finally right click on the request, click on “Flexmatch-instellingen” and select on the bottom Extern - “UZB Tadaah” – register/connect and click on save).
  
If you need help with setting up these steps, please contact SDB Support.`,
    connectWith: 'Connect with %{provider}',
    createJob: 'Create Job',
    createJobs: 'Create jobs',
    date: 'Date',
    end: 'End',
    fetchJobs: 'Fetch Jobs',
    fetchJobsDescription:
      'Enter the filters. Based on the filters, jobs will be fetched from SDB.',
    foundJobs: 'Found jobs (%{count})',
    from: 'From',
    function: 'Function',
    hideApiKey: 'Hide Api Key',
    integrations: 'integrations',
    jobCreated: 'Job Created',
    jobIsCreatedMessage:
      'Assignment has been created in Tadaah. View the job in the "assignments" section.',
    jobsFetchedFromSDB: 'Jobs fetched from SDB',
    jobsFound: 'Jobs Found',
    location: 'Location',
    maxRate: 'Maximum Rate (excl. VAT)',
    maxRateExempt: 'Maximum Rate (exempt)',
    noJobsFound: 'No jobs found',
    noJobsFoundInDateRange: 'No jobs were found within this date range.',
    organisationNotSelectedError:
      'Select an Organisation in the navigation menu.',
    sdbIntegration: 'SDB Integration',
    sdbIntegrationDescription:
      'Import jobs directly from SDB. Currently this is not a full integration, but you can import SDB jobs much more easily, and offer via Tadaah.',
    sdbJobAlreadyExistsError: 'This SDB job already exists in Tadaah.',
    sdbOrganisationAccount: 'SDB Organisation Account',
    selectBreakTime: 'Fill in the amount of break time in minutes.',
    selectCertificatesMultiple: 'Select Certificates (optional)',
    selectCompetence: 'Select a competence',
    selected: 'selected',
    selectedJobs: 'Selected Jobs (%{count})',
    selectJobs: 'Select Jobs',
    selectLocation: 'Select a location.',
    selectMaxRate: 'Enter an amount (€).',
    showApiKey: 'Show Api Key',
    start: 'Start',
    title: 'Title',
    to: 'Until',
    updateIntegration: 'Update Integration',
  };

export default organisationIntegrationSettingsLocales;
